var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.893,
    height: 11.38,
    viewBox: "0 0 14.893 11.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2810",
    "data-name": "Group 2810",
    transform: "translate(0 0.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M-5246.94,9090.34h-14.313",
    transform: "translate(5261.254 -9085.007)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M-5261.125,9085.267l5.336,5.337-5.336,5.336",
    transform: "translate(5269.974 -9085.267)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.744237a0c589ae33bf61b27cbfdfa9f5.svg";
export { ForwardRef as ReactComponent };